import React from "react";
import FileUpload from "./FileUpload";
import "./AvatarUpload.less";

interface CoverUploadProps {
  value?: AppAPI.FileInfo;
  onChange?: (fileInfo: AppAPI.FileInfo | undefined) => void;
  disabled?: boolean;
}

/**
 * 封面上传组件
 * 基于通用FileUpload组件实现
 */
const CoverUpload: React.FC<CoverUploadProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const config = {
    maxSize: 5, // 5MB
    allowedTypes: ["image/jpeg", "image/png"],
    accept: "image/jpeg,image/png",
    listType: "picture-card" as const,
    uploadText: "上传封面",
    helpText: "支持 JPG、PNG 格式，文件大小不超过 5MB",
    showPreview: true,
  };

  return (
    <div>
      <div style={{ marginBottom: 8, fontWeight: 500 }}>封面</div>
      <FileUpload
        value={value}
        onChange={onChange}
        disabled={disabled}
        config={config}
      />
    </div>
  );
};

export default CoverUpload;
